import { Injectable } from "@angular/core";

@Injectable()
export class PaginationService {
  constructor() {}

  pageProps = {
    next: null,
    previous: null,
    current: 1,
    pageToLoad: 1,
  };

  pageToLoad;
  pageCount;
  links;

  getPageProps(pageToLoad, pageCount, links) {
    this.pageToLoad = pageToLoad;
    this.pageCount = pageCount;
    this.links = links;

    this.paginate(this.pageToLoad);

    return this.pageProps;
  }

  private paginate(page) {
    switch (page) {
      case "first":
        this.loadFirst();
        break;
      case "previous":
        this.loadPrevious(this.links);
        break;
      case "next":
        this.loadNext(this.links);
        break;
      case "last":
        this.loadLast();
        break;
      default:
        this.loadFirst();
    }

    return;
  }

  private loadFirst() {
    this.pageProps.pageToLoad = 1;
    this.pageProps.current = 1;

    return;
  }

  private loadLast() {
    this.pageProps.pageToLoad = this.pageCount;
    this.pageProps.current = this.pageCount;

    return;
  }

  private loadNext(links) {
    if (links && links.next) {
      let pageNo = links.next.split("?page=");

      if (pageNo.length > 1 && pageNo[1].search("&") > 0) {
        pageNo = pageNo[1].split("&");
        this.pageProps.pageToLoad = pageNo[0];
        this.pageProps.current = pageNo[0];
      } else {
        this.pageProps.pageToLoad = pageNo[1];
        this.pageProps.current = pageNo[1];
      }
    }
    return;
  }

  private loadPrevious(links) {
    if (links && links.previous) {
      let pageNo = links.previous.split("?page=");

      if (pageNo[1] && pageNo[1].search("&") > 0) {
        pageNo = pageNo[1].split("&");
        this.pageProps.pageToLoad = pageNo[0] ? pageNo[0] : 1;
        this.pageProps.current = pageNo[0] ? pageNo[0] : 1;
      } else {
        this.pageProps.pageToLoad = pageNo[1] ? pageNo[1] : 1;
        this.pageProps.current = pageNo[1] ? pageNo[1] : 1;
      }
    }
    return;
  }
}
